<template>
  <h3 class="body-1-bold my-24">
    {{ i18n(translations.stepTitle) }}
  </h3>

  <template v-if="!isBuyback">
    <RevCheckbox
      id="all_market"
      v-model="allMarkets"
      class="my-24"
      variant="full"
    >
      <template #label>
        {{ i18n(translations.allMarketsLabel) }}
      </template>

      <template #description>
        {{ i18n(translations.allMarketsDescription) }}
      </template>
    </RevCheckbox>

    <h3 class="body-1-bold my-24">
      {{ i18n(translations.someMarketsTitle) }}
    </h3>

    <ul class="mb-24 list-none space-y-12">
      <li v-for="market in markets" :key="market">
        <RevCheckbox
          :id="market"
          v-model="selectedMarkets"
          :disabled="allMarkets"
          :value="market"
          variant="full"
        >
          <template #label>{{ i18n.country(market) }}</template>
        </RevCheckbox>
      </li>
    </ul>
  </template>

  <template v-if="isBuyback">
    <ul class="mb-24 list-none space-y-12">
      <li v-for="market in markets" :key="market">
        <RevRadio
          :id="market"
          v-model="selectedMarket"
          :value="market"
          variant="full"
        >
          <template #label>{{ i18n.country(market) }}</template>
        </RevRadio>
      </li>
    </ul>
  </template>

  <RevButton
    class="mt-auto"
    :disabled="isDisabled"
    full-width="always"
    type="submit"
    variant="primary"
    @click="goToNextStep"
  >
    {{ i18n(translations.cta) }}
  </RevButton>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import type { Country } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { isEmpty } from '@backmarket/utils/object/isEmpty'
import { RevButton } from '@ds/components/Button'
import { RevCheckbox } from '@ds/components/Checkbox'
import { RevRadio } from '@ds/components/Radio'

import translations from './MarketsSelection.translations'

const { defaultValue, markets, isBuyback } = defineProps<{
  markets: Country[] | undefined
  isBuyback: boolean
  defaultValue: string[] | null
}>()
const emit = defineEmits(['next-step'])

const i18n = useI18n()
const selectedMarket = ref(
  defaultValue !== null && defaultValue?.length ? defaultValue[0] : false,
)
const selectedMarkets = ref(defaultValue || [])
const allMarkets = ref(defaultValue === null)
const isDisabled = computed(() => {
  if (!isBuyback) {
    return !allMarkets.value && isEmpty(selectedMarkets.value)
  }

  return isEmpty(selectedMarket.value)
})

function goToNextStep() {
  if (allMarkets.value) {
    emit('next-step', { markets: null })
  } else {
    emit('next-step', {
      markets: isBuyback ? [selectedMarket.value] : selectedMarkets.value,
    })
  }
}
</script>
